import { render } from "./ChannelTokenManagement.vue?vue&type=template&id=48cbf53e&scoped=true"
import script from "./ChannelTokenManagement.vue?vue&type=script&lang=js"
export * from "./ChannelTokenManagement.vue?vue&type=script&lang=js"

import "./ChannelTokenManagement.vue?vue&type=style&index=0&id=48cbf53e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cbf53e"]])

export default __exports__